<template>
  <div class="addressList">
    <div class="navBar-wrap">
      <div class="select-navBar">
        <div class="arrow" @click="goBack"><van-icon name="arrow-left" /></div>
        <p class="title">{{ $t('关联会议') }}</p>
      </div>
    </div>
    <div class="addressList-nav">
      <div class="searchBox">
        <van-field
          v-model="searchName"
          :placeholder="$t('请输入搜索关键字')"
          :left-icon="require('@/assets/images/search.png')"
          class="search-name"
          @input="selectStaff"
        />
      </div>
    </div>
    <div v-if="relationList.length > 0">
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
        :style="{ height: height - 40 + 'px', overflow: 'auto' }"
      >
        <van-list
          v-model="myLoading"
          :finished="myFinished"
          @load="onLoad"
          :immediate-check="false"
        >
          <div class="loading-style" v-if="isLoading">
            <!-- <van-loading type="spinner" vertical>加载中...</van-loading> -->
          </div>
          <div class="content" v-else>
            <van-checkbox-group
              v-model="relationResult"
              class="relationList"
              :max="1"
            >
              <van-checkbox
                :name="index"
                class="relationListCard"
                icon-size="21px"
                v-for="(item, index) in relationList"
                :key="index"
                @click="clickRelation(index)"
              >
                <div class="relationListRange">{{ item.appointmentTopic }}</div>
              </van-checkbox>
            </van-checkbox-group>
          </div>
          <div class="bottom" v-show="showMyBottom">
            <div></div>
            <span>{{ $t(' _#_到底啦_#_') }}</span>
            <div></div>
          </div>
        </van-list>
      </van-pull-refresh>
      <div class="agreeBox">
        <van-button
          round
          block
          type="info"
          native-type="submit"
          class="agree-btn"
          @click="onConfirm"
          >{{ $t('确定') }}</van-button
        >
      </div>
    </div>
    <div class="no-uesdMeetingRoom" v-if="!relationList.length > 0">
      <img src="@/assets/images/empty.png" alt="" />
      <div>{{ $t('暂无信息') }}</div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import {
  Checkbox,
  CheckboxGroup,
  Button,
  Cell,
  CellGroup,
  Field,
  Radio,
  RadioGroup,
  Card,
  Popup,
  Calendar,
  Dialog,
  Toast,
  ActionSheet,
  Tab,
  Tabs,
  Search,
  PullRefresh,
  List,
  Loading,
} from 'vant'
import { queryMyRelation } from '@/services/api'
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Button)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Field)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Card)
Vue.use(Popup)
Vue.use(Calendar)
Vue.use(Toast)
Vue.use(ActionSheet)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Search)
Vue.use(PullRefresh)
Vue.use(List)
Vue.use(Dialog)
Vue.use(Loading)
export default {
  name: 'Address',
  props: ['selectedList'],
  components: {},
  data() {
    return {
      user: {},
      relationResult: [],
      relationList: [],
      myRelationPage: 1,
      searchName: '',
      isLoading: false,
      myLoading: false,
      myFinished: false,
      showMyBottom: false,
      height: '',
    }
  },
  methods: {
    async getRelation(user, flag) {
      try {
        let params = {
          companyId: user.companyId,
          staffId: user.id,
          page: this.myRelationPage,
          pageSize: 10,
          meetingName: this.searchName,
        }
        const res = await queryMyRelation(params)
        let temArr = res.results
        if (flag) {
          this.relationList = [...this.relationList, ...temArr]
        } else {
          this.relationList = temArr
        }
        if (
          this.relationList &&
          this.relationList.length &&
          this.selectedList
        ) {
          this.relationList.map((item, index) => {
            if (item.id == this.selectedList.id) {
              this.relationResult.push(index)
              return
            }
          })
        }
        this.myLoading = false
        this.isloading = false
        if (res && res.count <= this.myRelationPage * 10) {
          this.showMyBottom = true
          this.myFinished = true
        } else {
          this.showMyBottom = false
          this.myFinished = false
        }
      } catch (error) {
        console.log(error)
      }
    },
    async selectStaff(v) {
      this.searchName = v
      this.myRelationPage = 1
      this.getRelation(this.user, 0)
    },
    onLoad() {
      this.myRelationPage += 1
      this.getRelation(this.user, 1)
    },
    async onRefresh() {
      this.isLoading = true
      this.myRelationPage = 1
      this.getRelation(this.user, 1)
    },
    clickRelation(index) {
      if (this.relationResult.length < 2) return
      if (!this.relationResult.some((num) => num == index)) return
    },
    onConfirm() {
      if (!this.relationResult.length) {
        this.$emit('confirm', '')
      } else {
        this.$emit('confirm', this.relationList[this.relationResult])
      }
    },
    goBack() {
      this.$emit('back')
    },
  },
  computed: {},
  created() {
    this.user = JSON.parse(localStorage.getItem('user'))
  },
  mounted() {
    this.getRelation(this.user, 1)
    this.height = document.body.scrollHeight - 135
  },
}
</script>
<style lang="less" scoped>
.addressList {
  height: 100%;
  background-color: #ffffff;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  .addressList-nav {
    background-color: #ffffff;
    padding: 14px 18px 0;
    .searchBox {
      border: 1px solid #d9d9d9;
      border-radius: 2px;
      width: 340px;
      margin-bottom: 16px;
      // height: 30px;
      .search-name {
        padding: 3px 15px;
      }
    }
    .menu-box {
      display: flex;
      color: #009bff;
      font-size: 14px;
      line-height: 24px;
      white-space: nowrap;
      overflow: auto;
      .child-menu {
        display: flex;
        align-items: center;
        li {
          display: flex;
          align-items: center;
          padding-left: 8px;
          img {
            width: 16px;
            height: 17px;
            margin-right: 8px;
          }
        }
      }
    }
  }
  .agreeBox {
    width: 100%;
    background-color: #ffffff;
    bottom: 2px;
    left: 0;
    .agree-btn {
      border: none;
      width: 351px;
      margin: 0px auto;
    }
  }
}
.navBar-wrap {
  width: 100%;
  background: #ffffff;
  line-height: 40px;
  text-align: center;
  border-bottom: 1px solid #ececec;
  font-size: 18px;
  position: relative;
  .arrow {
    height: 100%;
    padding: 3px 19px;
    position: absolute;
  }
  .title {
    font-size: 17px;
    font-weight: 500;
  }
  .selected-navBar {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .left-icon {
      height: 100%;
      padding: 3px 19px;
      position: absolute;
      left: 0px;
    }
  }
}
.contact-card {
  display: flex;
  img {
    width: 19px;
    height: 21px;
    margin: 0px 7px;
  }
  > div {
    width: 1px;
    height: 20px;
    background: #ededed;
  }
}
.loading-style {
  width: 100%;
  text-align: center;
  margin-top: 50px;
}
.content {
  padding: 0 10px;
}
.relationList {
  position: relative;
  padding-left: 16px;
  overflow: auto;
  .relationListCard {
    height: 68px;
  }
  .relationListRange {
    display: block;
    border-bottom: 1px solid #ebebeb;
    padding-left: 6px;
    font-size: 16px;
    height: 68px;
    width: 375px;
    line-height: 68px;
    .staffName {
      padding-left: 24px;
    }
  }
}
.bottom {
  display: flex;
  align-items: center;
  padding: 30px 0;
  justify-content: center;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  line-height: 22px;
  > div {
    width: 96px;
    height: 1px;
    background: rgba(0, 0, 0, 0.15);
  }
  span {
    padding: 0 17px;
  }
}
.no-uesdMeetingRoom {
  margin-top: 44px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 24px;
  color: #666666;
  font-size: 14px;
  img {
    width: 96px;
    height: 61px;
    margin-bottom: 8px;
  }
}
</style>
